import axios from "axios";
import { Response } from "@/shared/models/Response";
import { AppointmentResponse } from "../models/AppointmentItem";

export class DoctorProfileService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_SCHEDULING_API}/medicalAppointment`;
  }

  async getAppointmentList(
    start: number,
    end?: number
  ): Promise<Response<AppointmentResponse>> {
    const endParam = end ? `&end=${end}` : "";
    const serviceURL = `${this.baseUrl}/appointments?start=${start}${endParam}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }
}
